var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "helper-button-container",
        { "bottom-distance": _vm.bottomDistance },
        { "bottom-distance-mobile": _vm.bottomDistanceOnMobile }
      ],
      on: {
        mouseleave: _vm.hideOptions,
        click: function($event) {
          return _vm.toggleOptions($event)
        }
      }
    },
    [
      _c("div", { class: ["question-icon", { close: _vm.showOptions }] }, [
        _vm._v(_vm._s(!_vm.showOptions ? `?` : `✕`))
      ]),
      _c("div", { class: ["circle", { "close-circle": _vm.showOptions }] }),
      _c("div", { class: ["help-tooltip"] }, [
        _vm.showOptions
          ? _c("div", { staticClass: "assistance" }, [
              _vm.hasContactCmt
                ? _c(
                    "a",
                    {
                      staticClass: "assistance-generic contact",
                      attrs: { href: "mailto:pavlina.venkova@akkodis.com" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.emailCmt.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.footer.contactCMT")) + " "
                      )
                    ]
                  )
                : _vm._e(),
              _vm.hasReportAProblem
                ? _c(
                    "span",
                    {
                      staticClass: "assistance-generic show-dialog",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.handleReportDialogShow($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("common.footer.reportProblem")) +
                          " "
                      ),
                      _vm.showSendReportDialog
                        ? _c("ReportAProblem", {
                            attrs: {
                              title: `${_vm.$t("projectPage.what")}`,
                              sending: _vm.sending
                            },
                            on: {
                              closeDialog: _vm.handleReportDialogClose,
                              handleMessage: _vm.sendEmailForProblem
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.hasResources
                ? _c(
                    "span",
                    {
                      staticClass: "assistance-generic resources",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.redirectToResources.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.footer.resources")) + " "
                      )
                    ]
                  )
                : _vm._e(),
              _vm.hasAssistance
                ? _c(
                    "div",
                    { staticClass: "assistance-generic assistance-container" },
                    [
                      _c("span", { staticClass: "assistance-message" }, [
                        _vm._v("Contact this email for assistance")
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "assistance-email",
                          on: { click: event => _vm.copyEmail(event) }
                        },
                        [_vm._v("pavlina.venkova@akkodis.com")]
                      )
                    ]
                  )
                : _vm._e()
            ])
          : _c("div", { staticClass: "assistance" }, [
              _c("span", { staticClass: "assistance-generic normalized" }, [
                _vm._v(_vm._s(_vm.$t("common.needHelp")))
              ])
            ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }